module.exports = __webpack_public_path__ + "icons/original/small/small-b4.5539a0f576453510700b7e1ac8ac62c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/small/small-b4.png
// module id = romA
// module chunks = app